export default "__VITE_ASSET__042785bf__"